import React from "react";

import { Button } from "clearsense-ui/components";

const Footer = ({ close, submit }) => (
  <>
    <Button
      label="Cancel"
      style="secondary"
      onClick={close}
      data-cy="edit-connection-cancel-button"
    />
    <Button
      label="Save Changes"
      onClick={submit}
      data-cy="edit-connection-submit-button"
    ></Button>
  </>
);

export default Footer;
